import React from "react";
import Icon from "./Icon";
export default function Search(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "15",
    y1: "15",
    x2: "20",
    y2: "20"
  }));
}
Search.displayname = "Search";
//# sourceMappingURL=Search.js.map